const DEVICE_ID_KEY = "app_device_id";

/**
 * Stable anonymous device id for rate-limiting assistance (not authentication).
 */
export function getOrCreateDeviceId(): string {
  try {
    const existing = localStorage.getItem(DEVICE_ID_KEY);
    if (existing && existing.trim()) {
      return existing.trim();
    }

    const id =
      typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
        ? crypto.randomUUID()
        : `device_${Math.random().toString(36).slice(2)}_${Date.now().toString(36)}`;

    localStorage.setItem(DEVICE_ID_KEY, id);
    return id;
  } catch {
    return `device_${Math.random().toString(36).slice(2)}_${Date.now().toString(36)}`;
  }
}

export function clearDeviceId(): void {
  try {
    localStorage.removeItem(DEVICE_ID_KEY);
  } catch {
    // ignore
  }
}
